export var defaultTableSelection = {
    hoveredColumns: [],
    hoveredRows: [],
    isInDanger: false,
};
//# sourceMappingURL=default-table-selection.js.map